import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { ICompany } from '../models/company';
import { CompanyService } from '../services/company.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyResolver  {
  constructor(private companyService: CompanyService){}

  resolve(
    route: ActivatedRouteSnapshot, 
    state: RouterStateSnapshot
    ): Observable<ICompany> {
    const id = route.paramMap.get("id");
    return this.companyService.getCompany(id);
  }
}
